import React from 'react';
import { addWindowListener, removeWindowListener, stopPropagation, } from 'app/utils/events';
import { useConfig } from './useConfig';
const showLeavePrompt = (evt) => {
    const confirmationMessage = 'Make sure. All your changes are saved before you leave';
    if (evt) {
        evt.returnValue = confirmationMessage;
        stopPropagation(evt);
    }
    return confirmationMessage;
};
function addLeavePrompt(window) {
    if (window) {
        if ('onbeforeunload' in window) {
            window.onbeforeunload = showLeavePrompt;
        }
        addWindowListener('beforeunload', showLeavePrompt);
    }
}
function removeLeavePrompt(window) {
    if (window) {
        if ('onbeforeunload' in window) {
            window.onbeforeunload = null;
        }
        removeWindowListener('beforeunload', showLeavePrompt);
    }
}
export function useBeforeUnload() {
    const { warnBeforeUnload } = useConfig({ warnBeforeUnload: true });
    React.useEffect(() => {
        if (window && warnBeforeUnload) {
            addLeavePrompt(window);
            return () => removeLeavePrompt(window);
        }
        return () => {
            /* noop */
        };
    }, [warnBeforeUnload]);
    return [];
}
